<template>
  <div :class="[resetable ? 'input-layout' : 'input-layout-empty']" class="bg-middle">
    <input v-if="procedure" disabled class="text-input bg-middle" type="text" :value="procedure.title">
    <input v-else class="text-input bg-middle" type="number" v-model.number="tenderIdInput" placeholder="ID (идентификатор) конкурса">
    <button v-if="resetable" @click="clear" class="input-icon-button bg-middle">
      <font-awesome-icon icon="times" />
    </button>
  </div>
</template>

<script>
// можно использовать разные темплейты для UI организации полей ввода
import { DataService } from '@/services/DataService.js'
import { mapGetters } from 'vuex'

export default {
  props: ['field'],
  watch: {
    value: {
      immediate: true,
      handler: function (value) {
        if (value) {
          this.$emit('editing', true)
          this.loadProcedure({ procId: value })
            .finally(() => { this.$emit('editing', false) })
        } else {
          this.procedure = null
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', ['user']),
    value () {
      return this.field.value
    },
    tenderIdInput: {
      get () {
        return this.tenderIdModel
      },
      set (id) {
        this.tenderIdModel = id
        this.$emit('editing', true)
        this.debounceLoad(id)
      }
    },
    resetable () {
      return (this.procedure && !this.procedure.error) || this.tenderIdModel
    }
  },
  data () {
    return {
      tenderIdModel: null,
      procedure: null,
      debounceLoad: this.$lo.debounce(this.loadInputProcedure, 1000)
    }
  },
  methods: {
    clear () {
      this.tenderIdModel = null
      this.procedure = null
      this.$emit('input', { value: null, debounced: false })
      this.$emit('editing', false)
      this.$emit('errors', null)
    },
    async loadProcedure ({ procId }) {
      return DataService.getProcedureLite({ filter: { id: [+procId] }, offset: 0, limit: 1 })
        .then(({ data }) => {
          this.$emit('errors', null)
          this.procedure = data && data.length ? data[0] : null
        })
        .catch(() => {
          this.$emit('errors', ['ошибка загрузки тендера, поробуйте обновить страницу'])
          this.procedure = { title: procId, error: true }
        })
    },
    async loadInputProcedure (id) {
      if (id) {
        this.loadProcedure({ procId: id }).finally(() => {
          if (this.procedure) {
            this.$emit('input', { value: this.procedure.id, debounced: true })
            this.$emit('editing', false)
            this.$emit('errors', null)
          } else {
            this.$emit('errors', ['конкурс не найден'])
          }
        })
      } else {
        this.clear()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-layout {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  align-items: center;
  height: 100%;
  width: 100%;
}
.input-layout-empty {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto;
  align-items: center;
  height: 100%;
  width: 100%;
}
</style>
